// Dependencies
import { Component } from 'react';
import Scrollbars from 'react-custom-scrollbars-2';
import { connect } from 'react-redux';

import Button from 'components/atoms/Button';
import Icon from 'components/atoms/Icon';
import Image from 'components/atoms/Image';
import TypeTag from 'components/atoms/TypeTag';
import { bindActionCreators, Dispatch } from 'redux';
import { SetErrorHandlerAction, setErrorHandlerAction } from 'store/actions/errorsActions';
import { SetLayoutAction, setLayoutAction } from 'store/actions/layoutActions';
import {
    EnviroDisplayOrderType,
    EnviroDisplayType,
    EventType,
    OpenModal,
    PortType,
    PortURLType,
    RootState,
    SwitchType,
    TagType,
    TransitDataType,
    TransitType,
    UserType,
} from 'types';
import {
    MainControlsInterface,
    MapControlsInterface,
    MetOceanChartControlsInterface,
    SearchControlsInterface,
} from 'types/functions';
import { FilterObjectType } from 'types/search';
import { SummaryData, SystemType } from 'types/system';
import { DateTimeFormat } from 'utils/dateTimeFormat';
import { checkDifferent } from 'utils/formHandlers';
import { getFlagImage, getFlagName } from 'utils/getVesselInfo';
import { formatEvents, getEnviroDisplayDataAvrages } from 'utils/migrations';
import { hasPermission } from 'utils/permission';
import { translate } from 'utils/translate';
import { twclsx } from 'utils/twclsx';
import ResultMessage from './filter/ResultMessage';

interface InspectTransitMenuComponentProps {
    active: boolean;
    mapControls: MapControlsInterface;
    mainControls: MainControlsInterface;

    dateTimeFormat: DateTimeFormat;

    inspectSelectedTime: DateTimeFormat;
    inspectTransit: string;
    inspectId: string;
    updateTransit: string | null;

    setLayoutAction: SetLayoutAction;
    tags: TagType[];
    port: PortType;
    switchs: SwitchType;
    openModelFunction: OpenModal;
    setErrorHandlerAction: SetErrorHandlerAction;
    metOceanChartControls: MetOceanChartControlsInterface;
    user: UserType;
    system: SystemType;
    searchId: string;
    searchControls: SearchControlsInterface;
    searchObject: FilterObjectType;
}

interface InspectTransitMenuComponentState {
    active: boolean;
    transit: TransitType | null | undefined;
    transitData: TransitDataType;
    tags: TagType[];
    activeMetOcean: boolean;
    environmentalSources: PortURLType[] | undefined;
    enviroDisplayOrder: EnviroDisplayOrderType[] | undefined;
    enviroDisplay: EnviroDisplayType | undefined;
    inspectTransit: string;
    inspectId: string;
    switchs: SwitchType;
    searchId: string;
    updateTransit: string | null;
    wind: boolean;
    watercurrent: boolean;
    wave: boolean;
    tide: boolean;
    loading: boolean;
    initialumbers: SummaryData;
    foundNumbers: SummaryData | null;
    searchNumbers: SummaryData | null;
}

class InspectTransitMenu extends Component<InspectTransitMenuComponentProps, InspectTransitMenuComponentState> {
    constructor(props: InspectTransitMenuComponentProps) {
        super(props);
        this.state = {
            active: props.active,
            transit: null,
            transitData: {},
            loading: false,
            inspectId: props.inspectId,
            inspectTransit: props.inspectTransit,
            activeMetOcean: true,
            wind: false,
            watercurrent: false,
            searchId: props.searchId,
            updateTransit: null,
            wave: false,
            initialumbers: {
                total: props.system.transits.total,
                inDateRangeForReview: props.system.transits.forReview,
                inDateRange: props.system.transits.total,
                forReview: props.system.transits.forReview,
                ppu: props.system.transits.ppu,
                simulated: props.system.transits.simulated,
                endDate: props.system.date.endDate.clone(), //clone from system start date
                startDate: props.system.date.startDate.clone(), //clone from system end date
                time: this.props.dateTimeFormat.parseDateTime(null, 'initialum time'),
            },
            tide: false,
            switchs: props.switchs,
            tags: [],
            foundNumbers: null,
            searchNumbers: null,
            enviroDisplayOrder: props.port.meta_data.enviroDisplayOrder,
            enviroDisplay: props.port.meta_data.enviroDisplay,
            environmentalSources: props.port.port_urls?.filter((x) => {
                return x.type === 'environmental';
            }),
        };
    }

    static getDerivedStateFromProps(props: InspectTransitMenuComponentProps, state: InspectTransitMenuComponentState) {
        if (checkDifferent(props.switchs, state.switchs)) {
            return {
                switchs: props.switchs,
            };
        }
        if (props.searchId !== state.searchId) {
            return {
                searchId: props.searchId,
            };
        }
        if (
            props.updateTransit !== state.updateTransit ||
            props.inspectId !== state.inspectId ||
            props.inspectTransit !== state.inspectTransit ||
            props.active !== state.active ||
            checkDifferent(props.tags, state.tags)
        ) {
            return {
                updateTransit: props.updateTransit,
                inspectId: props.inspectId,
                inspectTransit: props.inspectTransit,
                searchId: props.searchId,
                tags: props.tags,
                active: props.active,
                // activeMetOcean: state.inspectId !== props.inspectId ? state.inspectId : false,
            };
        }
        return null;
    }

    componentDidUpdate(
        prevProps: Readonly<InspectTransitMenuComponentProps>,
        prevState: Readonly<InspectTransitMenuComponentState>
    ): void {
        if (this.state.inspectTransit !== prevState.inspectTransit || this.state.inspectId !== prevState.inspectId) {
            const { transit, transitData } = this.props.mainControls.getTransit(this.state.inspectTransit);

            this.setState({
                transit,
                //@ts-ignore
                transitData,
                foundNumbers: this.props.searchControls.getFoundObjectNumbers(),
                searchNumbers: this.props.searchControls.getSearchObjectNumbers(),
            });
        }
        if (prevState.searchId !== this.state.searchId) {
            this.setState({
                foundNumbers: this.props.searchControls.getFoundObjectNumbers(),
                searchNumbers: this.props.searchControls.getSearchObjectNumbers(),
            });
        }
    }

    getTimeDiff(startTime, endTime) {
        // Calculate the difference between the two times
        const duration = endTime.date.diff(startTime.date, ['hours', 'minutes']);

        // Extract hours and minutes and ensure proper formatting
        const hours = Math.floor(duration.hours);
        const minutes = Math.round(duration.minutes);

        return `${String(hours)}${translate('hr')} ${String(minutes).padStart(2, '0')}${translate('mins')}`;
    }

    getOffsetDate = (key) => {
        //@ts-ignore
        const data = this.state.transitData[this.state.transit.best];
        //@ts-ignore
        const offset = this.state.transitData.offsets[data[0]?.vessel_offset_id];
        if (!offset) {
            return '-';
        }
        switch (key) {
            case 'heading':
                if (offset?.heading_correction?.toString()) {
                    return ` ${offset.heading_correction.toFixed(2)}  (${offset.heading.replace(' heading', '')})`;
                } else {
                    return 'N/A';
                }

            case 'lateral':
                if (offset?.heading_correction?.toString()) {
                    return `${offset.lateral_correction.toFixed(2)} (${offset.lateral.replace(' lateral', '')})`;
                } else {
                    return 'N/A';
                }

            default:
                break;
        }
    };

    toggleMetOceanMenu = () => {
        this.setState({
            activeMetOcean: !this.state.activeMetOcean,
        });
    };

    toggleMetOceanSubMenu = (key) => {
        //@ts-ignore
        this.setState((prevState) => ({
            [key]: !prevState[key],
        }));
    };

    getDisplay = (envirotype, key) => {
        return this.state?.enviroDisplay?.[envirotype][key];
    };

    openMetOceanChart = (type: string) => {
        // TODO
        // this.props.setLayoutAction('DEFAULT',
        //     'metOceanChart',
        //     ['grid', 'chart', 'analysis', 'draw', 'measure', 'menus'],
        //     ['playback', 'PlaybackTransit']
        // );
        //this.props.setLayoutAction('DEFAULT',{ tab: 'metOceanChart' });

        this.props.setLayoutAction([
            {
                action: 'UPDATE_DATA',
                data: {
                    section: 'metOceanChart',
                    data: {
                        backTo: 'chart',
                        vessel: this.state.transit?.vessel.name,
                        key: type,
                    },
                },
            },
            {
                action: 'UPDATE_SECTION',
                data: {
                    name: 'metOceanChart',
                    state: true,
                    display: true,
                    disable: false,
                },
            },
        ]);

        setTimeout(() => {
            //@ts-ignore
            this.props.metOceanChartControls.createTransitChart(
                type,
                this.state.transit,
                this.props.inspectSelectedTime
            );
        }, 100);
    };

    editTransit = (id: number | undefined) => {
        this.props.openModelFunction(
            'editTransitModel',
            0,
            'auto',
            { id: id },
            {
                onCancel: () => {
                    this.props.openModelFunction('editTransitModel');
                },
                onConfirm: () => {
                    //console.log('saved');
                },
            },
            true
        );
    };

    addTagsAndComments = (tab: string, id: number | undefined) => {
        this.props.openModelFunction(
            'transitTagsAndCommentsModel',
            0,
            'medium',
            { tab: tab, id: id },
            {
                onCancel: () => {
                    this.props.openModelFunction('transitTagsAndCommentsModel');
                },
                onConfirm: () => {
                    //console.log('saved');
                },
            },
            true
        );
    };

    render() {
        return (
            <div
                className={twclsx(
                    this.state.active ? 'left-0 ' : 'left-out',
                    'mt-14',
                    'h-page',
                    'border-r',
                    'border-gray-300',
                    'position-transition',
                    'fixed',
                    'z-20',
                    'w-smallMenu',
                    'ml-subMenu',
                    'h-page',
                    'top-0',
                    'bg-white'
                )}
                style={{ width: '300px' }}
            >
                <div className="flex gap-2 items-center border-b border-gray-200 py-3  px-2">
                    <div className="text-lg font-bold">{translate('inspect transit')}</div>

                    {/*hash close menu 'x'*/}
                    {/* <div
                        onClick={() => {
                            this.props.mainControls.inspectTransit(0);
                            this.props.mapControls.chart?.hideTooltips();
                            this.props.setLayoutAction([
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'inspectTransitMenu',
                                        section: 'chart',
                                        state: false,
                                    },
                                },
                                {
                                    action: 'UPDATE_MENU',
                                    data: {
                                        name: 'inspectTransitMenu',
                                        section: 'grid',
                                        state: false,
                                    },
                                },
                            ]);
                        }}
                        className="cursor-pointer"
                    >
                        <Icon>
                            <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                            <path d="M18 6l-12 12" />
                            <path d="M6 6l12 12" />
                        </Icon>
                    </div> */}
                </div>
                <div>
                    <ResultMessage
                        display="search"
                        limit={this.props.searchObject.limit}
                        isLoading={this.state.loading}
                        isFoundResults={this.state.foundNumbers !== null}
                        isSearchResults={this.state.foundNumbers !== null}
                        foundNumbers={this.state.foundNumbers}
                        initialumbers={this.state.initialumbers}
                        searchNumbers={this.state.foundNumbers}
                    >
                        <div className="  w-full  h-10 pt-3 justify-end  flex gap-2">
                            <Button
                                onClick={() => {
                                    this.setState({ loading: true }, () => {
                                        setTimeout(async () => {
                                            await this.props.mainControls.inspectTransit(0);
                                            this.props.setLayoutAction([
                                                {
                                                    action: 'UPDATE_MENU',
                                                    data: {
                                                        name: 'inspectTransitMenu',
                                                        section: 'chart',
                                                        state: true,
                                                        active: false,
                                                    },
                                                },
                                                {
                                                    action: 'UPDATE_MENU',
                                                    data: {
                                                        name: 'inspectTransitMenu',
                                                        section: 'grid',
                                                        state: true,
                                                        active: false,
                                                    },
                                                },
                                                {
                                                    action: 'UPDATE_MENU',
                                                    data: {
                                                        name: 'searchMenu',
                                                        section: 'chart',
                                                        state: true,
                                                        active: true,
                                                    },
                                                },
                                                {
                                                    action: 'UPDATE_MENU',
                                                    data: {
                                                        name: 'searchMenu',
                                                        section: 'grid',
                                                        state: true,
                                                        active: true,
                                                    },
                                                },
                                            ]);

                                            this.props.mapControls.chart?.hideTooltips();
                                            this.props.searchControls.clear();
                                            this.setState({ loading: false });
                                        }, 500);
                                    });
                                }}
                                type="button"
                                className="px-4 py-2 h-5 w-16 bg-primary-300 rounded-md text-white"
                            >
                                {translate('clear')}
                            </Button>
                        </div>
                    </ResultMessage>

                    <Scrollbars
                        className={twclsx('h-highlight', 'w-full', 'pr-1', 'mt-2')}
                        renderThumbVertical={({ style, ...props }) => (
                            <div
                                {...props}
                                style={{
                                    ...style,
                                    background: '#0000004a',
                                    borderRadius: 5,
                                    zIndex: 30, // Custom z-index
                                    position: 'relative', // Required for z-index to work
                                }}
                            />
                        )}
                    >
                        <div
                            className={twclsx(
                                this.state.transit === null || !this.state.transit?.mmsi
                                    ? 'h-full flex flex-col pt-2 pl-2'
                                    : ''
                            )}
                        >
                            {this.state.transit !== null && this.state.transit?.mmsi ? (
                                <div className="mt-2">
                                    <div>
                                        <div className="px-2 pb-2 flex flex-col border-b  border-gray-200">
                                            <div className="flex justify-between">
                                                <div className="flex flex-col">
                                                    <div className="font-bold capitalize">
                                                        <span
                                                            className={twclsx(
                                                                (!hasPermission(this.props.user, this.props.port.id, [
                                                                    'identifyTransits',
                                                                ]) ||
                                                                    !this.state.switchs.identifyTransits.value) &&
                                                                'blurText'
                                                            )}
                                                        >
                                                            <Image
                                                                alt={getFlagName(this.state.transit?.mmsi) || ''}
                                                                className="float-left mt-1 mr-1"
                                                                src={getFlagImage(this.state.transit?.mmsi) || ''}
                                                            />
                                                            {this.state.transit?.vessel.name}{' '}
                                                        </span>
                                                        ({translate(this.state.transit?.vessel.vessel_category.label)})
                                                    </div>
                                                </div>
                                                <div className="text-center">
                                                    <div>
                                                        {this.state.transit.transit_tags
                                                            .filter((transitTag) => {
                                                                return (
                                                                    transitTag.tag.type == 'type' &&
                                                                    transitTag.tag.status == 'active'
                                                                );
                                                            })
                                                            .sort((a, b) => {
                                                                if (a.tag?.order == null && b.tag?.order == null)
                                                                    return 0;
                                                                if (a.tag?.order == null) return 1;
                                                                if (b.tag?.order == null) return -1;

                                                                return a.tag.order - b.tag.order;
                                                            })

                                                            .map((transitTag, index) => {
                                                                if (index < 3) {
                                                                    return (
                                                                        <TypeTag key={index} type={transitTag.tag.type}>
                                                                            {translate(transitTag.tag.label)}
                                                                        </TypeTag>
                                                                    );
                                                                } else {
                                                                    return null;
                                                                }
                                                            })}
                                                    </div>
                                                    <div className="text-red-500 text-sm ">
                                                        {this.getTimeDiff(
                                                            this.state.transit.start_utc,
                                                            this.state.transit.end_utc
                                                        )}{' '}
                                                    </div>
                                                </div>
                                            </div>

                                            <div>
                                                {formatEvents(this.state.transit.events).map((event: EventType) => {
                                                    return (
                                                        <TypeTag
                                                            key={event.id}
                                                            type="positioning"
                                                            className="mr-1 mt-1"
                                                        >
                                                            <>
                                                                {event.description}{' '}
                                                                <span className="lowercase ml-1">
                                                                    {translate('at')}
                                                                </span>
                                                                <span className="ml-1 text-red-500">
                                                                    {this.props.dateTimeFormat
                                                                        .parseDateTime(event.valid_time_utc)
                                                                        .formatDateTimeToString('HH:mm')}
                                                                </span>
                                                            </>
                                                        </TypeTag>
                                                    );
                                                })}
                                            </div>
                                        </div>
                                        <div className="px-2 pb-2 border-b  border-gray-200">
                                            <div className="flex justify-between py-2">
                                                <div className="font-bold no-select w-full">
                                                    {translate('Tags and comments')}
                                                </div>
                                            </div>

                                            <div>
                                                <div>
                                                    {this.state.tags
                                                        ?.filter((tag: TagType) =>
                                                            ['private', 'public', 'analysis'].includes(tag.type)
                                                        )
                                                        .sort((a, b) => {
                                                            // 1️⃣ type priority
                                                            const typePriority = (type: string) => {
                                                                if (type === 'private' || type === 'public') return 0;
                                                                if (type === 'analysis') return 1;
                                                                return 2;
                                                            };

                                                            const typeDiff =
                                                                typePriority(a.type) - typePriority(b.type);
                                                            if (typeDiff !== 0) return typeDiff;

                                                            // 2️⃣ order inside same type group
                                                            if (a?.order == null && b?.order == null) return 0;
                                                            if (a?.order == null) return 1;
                                                            if (b?.order == null) return -1;

                                                            return a.order - b.order;
                                                        })
                                                        ?.filter((tag: TagType) =>
                                                            this.state.transit?.transit_tags
                                                                .map((x) => x.tag_id)
                                                                .includes(tag.id)
                                                        )
                                                        .map((tag: TagType) => (
                                                            <TypeTag
                                                                onClick={() => {
                                                                    this.addTagsAndComments(
                                                                        'tags',
                                                                        this.state.transit?.id
                                                                    );
                                                                }}
                                                                key={tag.id}
                                                                className="mr-1 mt-1"
                                                                type={tag.type}
                                                            >
                                                                {tag.label}
                                                            </TypeTag>
                                                        ))}

                                                    <span
                                                        className="mt-1"
                                                        onClick={() => {
                                                            this.addTagsAndComments('comments', this.state.transit?.id);
                                                        }}
                                                    >
                                                        <TypeTag type="user">
                                                            {translate('comments')} {this.state.transit.comments.length}
                                                        </TypeTag>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>

                                        {this.state.switchs?.chartEnviromentalDataOnLeftColumn?.value && (
                                            <div className="pl-2 pr-3  border-b  border-gray-200">
                                                <div className="flex justify-between py-2 ">
                                                    <div className="font-bold no-select">
                                                        {translate('MetOcean data')}
                                                    </div>

                                                    <div onClick={this.toggleMetOceanMenu} className="cursor-pointer">
                                                        {this.state.activeMetOcean ? (
                                                            <Icon className="w-4.5 h-4.5">
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                                <path d="M6 15l6 -6l6 6" />
                                                            </Icon>
                                                        ) : (
                                                            <Icon className="w-4.5 h-4.5">
                                                                <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                                                <path d="M6 9l6 6l6 -6" />
                                                            </Icon>
                                                        )}
                                                    </div>
                                                </div>

                                                {this.state.activeMetOcean && (
                                                    <div>
                                                        {getEnviroDisplayDataAvrages(
                                                            this.state.transit,
                                                            this.state.environmentalSources,
                                                            this.state.enviroDisplayOrder,
                                                            this.state.enviroDisplay
                                                        )
                                                            .filter((info) => {
                                                                return (
                                                                    info.instruments.length &&
                                                                    this.props.switchs[`${info.key}Data`].value
                                                                );
                                                            })
                                                            .map((info) => {
                                                                return (
                                                                    <div
                                                                        className="mb-1 border-b border-gray-200 pt-1"
                                                                        key={info.key}
                                                                    >
                                                                        <div className="flex justify-between">
                                                                            <div className="font-bold text-primary-link">
                                                                                {translate(info.key)}{' '}
                                                                                {translate('data averages')}
                                                                            </div>
                                                                            <div className="flex gap-1">
                                                                                <div
                                                                                    onClick={() => {
                                                                                        this.openMetOceanChart(
                                                                                            info.key
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    <Icon className="w-4 h-4 cursor-pointer">
                                                                                        <path d="M10 3.2a9 9 0 1 0 10.8 10.8a1 1 0 0 0 -1 -1h-3.8a4.1 4.1 0 1 1 -5 -5v-4a.9 .9 0 0 0 -1 -.8"></path>
                                                                                        <path d="M15 3.5a9 9 0 0 1 5.5 5.5h-4.5a9 9 0 0 0 -1 -1v-4.5"></path>
                                                                                    </Icon>
                                                                                </div>
                                                                                <div
                                                                                    onClick={() => {
                                                                                        this.toggleMetOceanSubMenu(
                                                                                            info.key
                                                                                        );
                                                                                    }}
                                                                                >
                                                                                    {this.state[info.key] ? (
                                                                                        <Icon className="w-4.5 h-4.5 cursor-pointer">
                                                                                            <path
                                                                                                stroke="none"
                                                                                                d="M0 0h24v24H0z"
                                                                                                fill="none"
                                                                                            />
                                                                                            <path d="M6 15l6 -6l6 6" />
                                                                                        </Icon>
                                                                                    ) : (
                                                                                        <Icon className="w-4.5 h-4.5 cursor-pointer">
                                                                                            <path
                                                                                                stroke="none"
                                                                                                d="M0 0h24v24H0z"
                                                                                                fill="none"
                                                                                            />
                                                                                            <path d="M6 9l6 6l6 -6" />
                                                                                        </Icon>
                                                                                    )}
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                        {this.state[info.key] && (
                                                                            <>
                                                                                {info.instruments.map(
                                                                                    (instrument, instrumentIndex) => {
                                                                                        return (
                                                                                            <div key={instrumentIndex}>
                                                                                                <div>
                                                                                                    {' '}
                                                                                                    {
                                                                                                        instrument.description
                                                                                                    }{' '}
                                                                                                </div>
                                                                                                <div className="border-b pb-1 mb-1 border-gray-200">
                                                                                                    {instrument.values.map(
                                                                                                        (
                                                                                                            value,
                                                                                                            valueIndex
                                                                                                        ) => {
                                                                                                            return (
                                                                                                                <div
                                                                                                                    className={` flex justify-between items-center`}
                                                                                                                    key={
                                                                                                                        valueIndex
                                                                                                                    }
                                                                                                                >
                                                                                                                    <p className=" whitespace-no-wrap  text-sm  font-medium text-gray-900">
                                                                                                                        {
                                                                                                                            value.name
                                                                                                                        }
                                                                                                                    </p>

                                                                                                                    <p className=" whitespace-no-wrap  text-sm  font-medium text-gray-900">
                                                                                                                        {
                                                                                                                            value.value
                                                                                                                        }{' '}
                                                                                                                        {
                                                                                                                            value.unit
                                                                                                                        }
                                                                                                                    </p>
                                                                                                                </div>
                                                                                                            );
                                                                                                        }
                                                                                                    )}
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                )}
                                                                            </>
                                                                        )}
                                                                    </div>
                                                                );
                                                            })}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                        <div className="pl-2 pr-3 pb-2">
                                            <div className="flex justify-between py-2">
                                                <div className="font-bold no-select  ">
                                                    {translate('Transit admin')}
                                                </div>
                                            </div>
                                            <div>
                                                <div className=" flex flex-col  ">
                                                    <div className="flex flex-col justify-start">
                                                        <div className="flex justify-between">
                                                            <div className="flex   justify-start gap-1 items-center text-sm">
                                                                <span className="text-gray-600 font-bold">
                                                                    {translate('Data')}:
                                                                </span>
                                                                <p>{translate(this.state.transit.best)}</p>
                                                            </div>
                                                            <div className="flex  justify-start gap-1 items-center text-sm">
                                                                <span className="text-gray-600 font-bold">
                                                                    {translate('AIS')}:
                                                                </span>
                                                                <p>{translate('received')}</p>
                                                            </div>
                                                        </div>
                                                        <div className="flex justify-between">
                                                            <div className="flex  justify-start gap-1  items-center text-sm">
                                                                <span className="text-gray-600 font-bold">
                                                                    {translate('Lateral offsets')}:
                                                                </span>
                                                                <p>{this.getOffsetDate('lateral')}</p>
                                                            </div>
                                                            <div className="flex   justify-start gap-1 items-center text-sm">
                                                                <span className="text-gray-600 font-bold">
                                                                    {translate('MetOcean')}:
                                                                </span>
                                                                <p>
                                                                    {this.state.transit.environmental
                                                                        ? translate('Done')
                                                                        : translate('not received')}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="flex justify-between">
                                                            <div className="flex  justify-start gap-1  items-center text-sm">
                                                                <span className="text-gray-600 font-bold">
                                                                    {translate('Heading offset')}:
                                                                </span>
                                                                <p>{this.getOffsetDate('heading')}</p>
                                                            </div>
                                                            <div className="flex  justify-start gap-1 items-center text-sm">
                                                                <span className="text-gray-600 font-bold">
                                                                    {translate('Calculations')}:
                                                                </span>
                                                                <p>
                                                                    {this.state.transit.analysis
                                                                        ? translate('Done')
                                                                        : translate('not completed')}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="flex justify-between">
                                                            <div className="flex  justify-start gap-1 items-center text-sm">
                                                                <span className="text-gray-600 font-bold">
                                                                    {translate('Processed')}:
                                                                </span>
                                                                <p className="text-red-500">
                                                                    {this.state.updateTransit ===
                                                                        this.state.inspectTransit
                                                                        ? translate('Reprocessing…')
                                                                        : this.state.transit.updated_at.formatDateTimeToString(
                                                                            'dd MMM yyyy HH:mm:ssZ'
                                                                        )}
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ) : (
                                <div className="flex items-center gap-1">
                                    <Icon className="h-5 w-5">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                                        <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                                        <path d="M12 9h.01" />
                                        <path d="M11 12h1v4h1" />
                                    </Icon>
                                    <div className="text-center">{translate('select transit to inspect')}</div>
                                </div>
                            )}
                        </div>
                    </Scrollbars>
                </div>
            </div>
        );
    }
}

const inspectTransitMenuStateToProps = (state: RootState) => ({
    mapControls: state.map.mapControls,
    mainControls: state.layout.mainControls,
    metOceanChartControls: state.layout.metOceanChartControls,
    dateTimeFormat: state.port.dateTimeFormat,
    tags: state.port.tags,
    system: state.port.system,
    inspectSelectedTime: state.layout.layout.inspectSelectedTime,
    inspectTransit: state.layout.layout.inspectTransit,
    inspectId: state.layout.layout.inspectId,
    updateTransit: state.layout.layout.updateTransit,
    port: state.port.port,
    switchs: state.layout.switchs,
    openModelFunction: state.layout.openModelFunction,
    user: state.user.user,
    layout: state.layout,
    searchId: state.layout.layout.searchId,
    searchControls: state.layout.searchControls,
    searchObject: state.layout.searchObject,
});

const inspectTransitMenuDispatchToProps = (dispatch: Dispatch) => ({
    setErrorHandlerAction: bindActionCreators(setErrorHandlerAction, dispatch),
    setLayoutAction: bindActionCreators(setLayoutAction, dispatch),
});

export default connect(inspectTransitMenuStateToProps, inspectTransitMenuDispatchToProps)(InspectTransitMenu);
